import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from "./App";
import {commonDataLoad} from "./services/common_data";

commonDataLoad();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(  
    <App />
);
